module.exports = __webpack_public_path__ + "img/8.23245d09.png";